import { render, staticRenderFns } from "./cTitle.vue?vue&type=template&id=cf8ab486&scoped=true&"
import script from "./cTitle.vue?vue&type=script&lang=js&"
export * from "./cTitle.vue?vue&type=script&lang=js&"
import style0 from "./cTitle.vue?vue&type=style&index=0&id=cf8ab486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8ab486",
  null
  
)

export default component.exports